import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useSelector, useDispatch} from 'react-redux'
import { register, reset } from '../features/auth/authSlice'

const Register = () => {

  const [form, setForm] = useState({
    name: "",
    email: "",
    password: ""
  })

  const { name, email, password } = form

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { user, success, error, message } = useSelector(state => state.auth)
  
  useEffect(() => {
    if (error) {
      toast.error(message)
    }
    if (success || user) {
      navigate('/login')
    }
    dispatch(reset())
  }, [error, success, user, message, navigate, dispatch])

  const onChange = (e) => {
    setForm({  ...form, [e.target.name]: e.target.value })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
   
    const userData = {
      name, email, password
    }
    dispatch(register(userData))
    navigate('/login')
  }

  return (
    <div style={containerStyle}>
      <div style={formCardStyle}>
        <h1 style={titleStyle}>📝 Registro</h1>
        <p style={subtitleStyle}>Crea tu cuenta en el Sistema POS</p>
        
        <form onSubmit={handleSubmit}>
          <div style={formGroupStyle}>
            <label style={labelStyle}>👤 Nombre</label>
            <input
              type="text"
              placeholder="Tu nombre completo"
              name="name"
              value={name}
              onChange={onChange}
              style={inputStyle}
              required
            />
          </div>

          <div style={formGroupStyle}>
            <label style={labelStyle}>📧 Email</label>
            <input
              type="email"
              placeholder="tu@email.com"
              name="email"
              value={email}
              onChange={onChange}
              style={inputStyle}
              required
            />
          </div>

          <div style={formGroupStyle}>
            <label style={labelStyle}>🔒 Contraseña</label>
            <input
              type="password"
              placeholder="••••••••"
              name="password"
              value={password}
              onChange={onChange}
              style={inputStyle}
              required
            />
          </div>

          <button type="submit" style={btnRegisterStyle}>
            ✅ Registrarse
          </button>

          <div style={linkContainerStyle}>
            <a href="/login" style={linkStyle}>
              ¿Ya tienes cuenta? Inicia sesión aquí
            </a>
          </div>
        </form>
      </div>
    </div>
  );
};

// Estilos
const containerStyle = {
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
  fontFamily: 'Arial, sans-serif',
  padding: '20px',
};

const formCardStyle = {
  background: 'white',
  padding: '40px',
  borderRadius: '16px',
  boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
  width: '100%',
  maxWidth: '450px',
};

const titleStyle = {
  textAlign: 'center',
  color: '#333',
  marginBottom: '10px',
  fontSize: '32px',
};

const subtitleStyle = {
  textAlign: 'center',
  color: '#666',
  marginBottom: '30px',
  fontSize: '16px',
};

const formGroupStyle = {
  marginBottom: '20px',
};

const labelStyle = {
  display: 'block',
  marginBottom: '8px',
  color: '#333',
  fontWeight: '600',
  fontSize: '14px',
};

const inputStyle = {
  width: '100%',
  padding: '12px 15px',
  borderRadius: '8px',
  border: '2px solid #e0e0e0',
  fontSize: '16px',
  transition: 'border-color 0.3s',
  boxSizing: 'border-box',
  outline: 'none',
};

const btnRegisterStyle = {
  width: '100%',
  padding: '14px',
  borderRadius: '8px',
  border: 'none',
  background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
  color: 'white',
  fontSize: '18px',
  fontWeight: 'bold',
  cursor: 'pointer',
  transition: 'transform 0.2s',
  marginTop: '10px',
};

const linkContainerStyle = {
  textAlign: 'center',
  marginTop: '20px',
};

const linkStyle = {
  color: '#11998e',
  textDecoration: 'none',
  fontSize: '14px',
  fontWeight: '600',
};

export default Register